<template>
  <div class="wrapper bg-grey-lightest">
    <div class="main-content-wrap">
      <div class="main-content-pannel">
        <div
          class="option-wrap bg-grey-lightest grey-bg-option no-border"
          style="margin-top: 24px"
        >
          <div class="options">
            <div class="content-title-wrap p-t-0">
              <div class="main-content-title">
                {{ project ? project.title : "" }}
              </div>
            </div>
          </div>
        </div>
        <div class="main-flex" v-if="project">
          <div class="main-flex-1">
            <div class="pannel-1">
              <div class="pannel-1-title">
                <h3>Task</h3>
              </div>
              <div class="pannel-1-body project-detail-task">
                <p class="preline" v-html="project.task" />
                <h6>
                  <i class="material-icons-outlined align-middle"
                    >account_balance</i
                  >Client Description:
                </h6>
                <p class="preline" v-html="project.client_description" />
              </div>
              <div v-if="role">
                <div class="relative">
                  <div class="hr"></div>
                  <div class="pannel-1-title">
                    <h3 class="cursor-default">
                      {{ role.title }}
                    </h3>
                  </div>
                  <div class="pannel-1-body project-detail-task">
                    <p class="preline" v-html="role.requirements" />
                    <p class="inline">
                      <label
                        ><i class="material-icons align-middle">account_box</i
                        >Tech Level</label
                      >
                      <span class="tech_lvl_tag"
                        ><i class="material-icons align-middle">stream</i
                        >{{ role.tech_level }}</span
                      >
                    </p>
                    <p class="inline">
                      <label
                        ><i class="material-icons align-middle">east</i
                        >Engagement Length</label
                      >
                      {{ role.engagement }}
                    </p>
                    <p class="inline">
                      <label
                        ><i class="material-icons-outlined align-middle"
                          >logout</i
                        >Estimated Start</label
                      >
                      {{ role.estimated_start | dateformatFilter("D/M/YYYY") }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="main-flex-1">
            <div v-if="!consultantId">
              <div class="login-apply-wrapper">
                <div>
                  Are you already an member of ScaleDesk? Just login here with
                  Google to Apply to the role
                </div>
                <router-link
                  :to="{
                    path: `/login`,
                    query: { project_id: projectId, role_id: roleId },
                  }"
                >
                  <div class="login-apply-buttom">
                    <i class="material-icons align-middle">logout</i>
                    <div>Apply with Google Login</div>
                  </div>
                </router-link>
              </div>
              <div class="typeform-wrapper">
                <div class="typeform-title">Apply as a new member!</div>
                <div class="typeform-content">
                  <iframe class="typeform-iframe" :src="iframSrc" />
                </div>
              </div>
            </div>
            <div v-if="consultant">
              <div class="login-apply-wrapper">
                <div>
                  Hi, {{ consultant.name
                  }}{{ applied ? ", you are applied to this project" : "" }}
                </div>
                <div
                  class="login-apply-buttom"
                  @click="onApply"
                  v-if="!applied"
                >
                  <i class="material-icons align-middle">logout</i>
                  <div>Apply</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/vendor/firebase";
import moment from "moment-timezone";
import ApplyForm from "@/components/ApplyForm";
import * as database from "@/vendor/database";

export default {
  components: {
    ApplyForm,
  },
  data() {
    return {
      projectId: null,
      roleId: null,
      project: null,
      role: null,
      iframSrc: "",
      consultantId: null,
      consultant: null,
      isLoading: false,
    };
  },
  watch: {
    project: function () {
      this.project.start = moment(this.project.estimated_start * 1000).format(
        "MM/DD/YYYY"
      );
      if (this.project.roles && this.project.roles.length > 0) {
        this.role = this.project.roles.find((item) => item.id === this.roleId);
      }
    },
  },
  computed: {
    applied() {
      return this.project?.selected_consultants
        ?.find((item) => item.role_id === this.roleId)
        ?.consultants?.some((item) => item.id === this.consultantId)
        ? true
        : false;
    },
  },
  beforeMount() {
    const { project, role, consultant } = this.$route.query;
    this.projectId = project;
    this.roleId = role;
    this.consultantId = consultant;
    this.iframSrc = `https://form.typeform.com/to/LALgTBQU#project=${project}&role=${role}`;
    this.bindData();
  },
  methods: {
    bindData: function () {
      if (this.projectId && this.roleId) {
        this.$bind("project", db.collection("gigs").doc(this.projectId));
      }
      if (this.consultantId) {
        this.$bind(
          "consultant",
          db.collection("consultants").doc(this.consultantId)
        );
      }
    },
    backToProjects() {
      this.$router.push("/available_projects");
    },
    onApply: async function () {
      if (this.isLoading) return;
      const consultantData = {
        id: this.consultantId,
        status: "Added",
      };
      let selectedConsultants = [];
      if (
        this.project.selected_consultants &&
        this.project.selected_consultants.length > 0
      ) {
        selectedConsultants = JSON.parse(
          JSON.stringify(this.project.selected_consultants)
        );
      }
      const roleData = selectedConsultants.find(
        (item) => item.role_id === this.roleId
      );
      if (roleData) {
        if (roleData.consultants) {
          roleData.consultants.push(consultantData);
        } else {
          roleData.consultants = [consultantData];
        }
      } else {
        selectedConsultants.push({
          role_id: this.roleId,
          consultants: [consultantData],
        });
      }
      this.isLoading = true;
      await database.updateDocById("gigs", this.projectId, {
        selected_consultants: selectedConsultants,
      });
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.wrapper {
  flex: 1;
  display: flex;
  max-width: 1440px;
  margin: 0 auto;
}
.relative {
  position: relative;
}
.no-hover > div:hover {
  background: #fff;
}
.mt {
  margin-top: 30px;
  margin-right: 10px;
}
.mt-5 {
  margin-top: 5px;
  margin-right: 5px;
}
.check-button {
  width: 30px;
  height: 30px;
  cursor: pointer;
  padding-top: 8px;
  font-weight: 900;
  color: #cccccc;
}
.preline {
  white-space: pre-line;
}
.name-wrapper {
  display: flex;
}
.ml {
  margin-left: 5px;
}
.cursor-pointer {
  cursor: pointer;
}
.files-wrapper {
  width: 100%;
  padding: 20px;
  border-top: 1px solid var(--border-grey-lightest);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.files-wrapper > label {
  font-family: avenir-next-block;
  font-size: 12px;
}
.files-wrapper > *:not(:first-child) {
  margin-top: 4px;
}
.verified-tag {
  position: absolute;
  top: 0;
  right: 0;
}
.verified-tag::before,
.verified-tag::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  border-color: transparent;
  border-style: solid;
}

.verified-tag::before {
  border-width: 16px;
  border-right-color: transparent;
  border-top-color: transparent;
}

.verified-tag::after {
  border-width: 16px;
  border-right-color: #437512;
  border-top-color: #437512;
}
.relative {
  position: relative;
}
.flex-wrapper {
  display: flex;
  align-items: center;
}
.consultant-action {
  display: none;
  position: absolute;
  right: 15px;
  top: 15px;
  font-size: var(--font-size-l);
}
.action-wrapper {
  cursor: pointer;
}
.action-wrapper:hover .consultant-action {
  display: block;
}
.quote-wrapper {
  border: 2px solid #0085ff;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.1), 0px 3px 3px rgba(0, 0, 0, 0.06),
    0px 3px 4px rgba(0, 0, 0, 0.08);
}
.use-wrapper {
  display: flex;
  align-items: center;
}
.user-name {
  color: var(--blue-light);
}
.user-name:hover {
  text-decoration: underline;
}
.new-project-message-wrapper {
  margin: var(--margin-3l);
}
.login-apply-wrapper {
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 1px rgba(0, 0, 0, 0.06),
    0px 1px 1px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 24px;
  font-size: 20px;
  line-height: 28px;
  color: #585757;
}
.login-apply-buttom {
  background: #0085ff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 1px rgba(0, 0, 0, 0.06),
    0px 1px 1px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  margin: 24px auto 0;
  width: 347px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #ffffff;
  font-family: inter-regular;
}
.login-apply-buttom > i {
  font-size: 20px;
  margin-right: 8px;
}
.typeform-wrapper {
  margin-top: 20px;
}
.typeform-title {
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #1c1c1c;
  font-family: inter-regular;
}
.typeform-content {
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 1px rgba(0, 0, 0, 0.06),
    0px 1px 1px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  margin-top: 8px;
}
.typeform-iframe {
  height: 541px;
  border: none;
  width: 100%;
}
</style>
